import { render, staticRenderFns } from "./personal.vue?vue&type=template&id=6f84330c&scoped=true"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"
import style0 from "./personal.vue?vue&type=style&index=0&id=6f84330c&prod&lang=less&scoped=true"
import style1 from "./personal.vue?vue&type=style&index=1&id=6f84330c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f84330c",
  null
  
)

export default component.exports